import { render, staticRenderFns } from "./otherInfo.vue?vue&type=template&id=44381821&"
import script from "./otherInfo.vue?vue&type=script&lang=js&"
export * from "./otherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports